import "./App.css";
import loadable from "@loadable/component";

const Header = loadable(() => import('./components/Header'))
const Home = loadable(() => import('./components/Home'))
const Resume = loadable(() => import('./components/Resume'))
const Skill = loadable(() => import('./components/Skill'))
const Portofolio = loadable(() => import('./components/Portofolio'))
const Certificate = loadable(() => import('./components/Certificate'))
const Contact = loadable(() => import('./components/Contact'))
const Footer = loadable(() => import('./components/Footer'))

function App() {
  return (
    <div>
      <Header />
      <Home />
      <Portofolio />
      <Skill />
      <Certificate />
      <Resume />
      {/* <Contact /> */}
      <Footer />
    </div>
  );
}

export default App;
